import React, { Component } from 'react';
import ImagiApp from './containers/ImagiApp';
import { BrowserRouter } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import Mobile from './containers/Mobile'
import Amplify from 'aws-amplify'
import AWS from 'aws-sdk'




// Google Play and the Google Play logo are trademarks of Google LLC.

Amplify.configure({
  Auth: {

    identityPoolId: 'eu-west-1:9eb6977d-76e2-45af-9c93-735f7cc9ac90',
    region: 'eu-west-1',
    identityPoolRegion: 'eu-west-1',
    userPoolId: 'eu-west-1_oDBp81Bpl',
    userPoolWebClientId: '5ljs05e9kkp2tc5ktm5vs7p1g0',
    mandatorySignIn: true,

  }
})

AWS.config.region = 'eu-west-1';

AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: 'eu-west-1:9eb6977d-76e2-45af-9c93-735f7cc9ac90',

});



class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <BrowserView>

          <ImagiApp />

        </BrowserView>

        <MobileView>
          <Mobile/>
        </MobileView>
      </BrowserRouter>


    )
  }
}
export default App;